<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap pega-auto-reply-container">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="応募者管理＿自動受付メッセージ設定"
      />
      <div>
        <h3 class="boss-joboffer-title boss-setting">
          応募受付メッセージ自動送信設定
        </h3>

        <form-label
          label="自動送信利用設定"
          is-required
        >
          <template #body>
            <div class="pega-entry-auto-reply-relative">
              <div class="pega-width-40 pega-auto-reply-item-area">
                <div
                  v-for="(whetherToUse, i) in autoReplyOptions.whetherToUses"
                  :key="i"
                >
                  <label class="pega-badge-radio pega-mr-5">
                    <input
                      v-model="autoReplySetting.isAvailableAutoReplyMail"
                      :value="whetherToUse.value"
                      type="radio"
                      :data-test="`use-auto-reply-radio${i}`"
                    >
                    <span
                      class="pega-badge-radio-text pega-badge-radio-check-mark"
                      :data-test="`use-auto-reply-label${i}`"
                    >{{ whetherToUse.label }}</span>
                  </label>
                </div>
              </div>
              <div class="pega-width-60 pega-annotation-text-padding">
                <div>
                  <a
                    href="/help/guide/index_273.html"
                    data-test="use-manual-link"
                    target="_blank"
                  >
                    応募受付自動送信機能とは？
                  </a>
                </div>
              </div>
            </div>
          </template>
        </form-label>
        <form-label
          label="送信対象設定"
          is-required
        >
          <template #body>
            <div class="pega-entry-auto-reply-relative">
              <div class="pega-width-40 pega-auto-reply-item-area">
                <div
                  v-for="(allReply, i) in autoReplyOptions.allReplies"
                  :key="i"
                >
                  <label class="pega-badge-radio pega-mr-5">
                    <input
                      v-model="autoReplySetting.isNoAutoReplyForScoutEntry"
                      :value="allReply.value"
                      type="radio"
                      :data-test="`auto-reply-target-radio${i}`"
                    >
                    <span
                      class="pega-badge-radio-text pega-badge-radio-check-mark"
                      :data-test="`auto-reply-target-label${i}`"
                    >{{ allReply.label }}</span>
                  </label>
                  <small
                    v-if="allReply.note"
                    :data-test="`auto-reply-target-note${i}`"
                  >{{ allReply.note }}</small>
                </div>
              </div>
              <div class="pega-width-60 pega-annotation-text-padding">
                <div>■ スカウトメールをご利用されている場合</div>
                <div>・スカウト応募者に対して応募受付メッセージを自動送信したくない場合は除外設定が可能です。</div>
                <div>例）すぐに面接案内をしたい/スカウト応募者には特別な対応をしたい など</div>
                <div>※ただし、スカウト応募者限定の応募受付メッセージの設定はできませんので、個別の対応をお願い致します</div>
              </div>
            </div>
          </template>
        </form-label>
        <form-label
          label="送信時間設定"
          is-required
        >
          <template #body>
            <div class="pega-entry-auto-reply-relative">
              <div class="pega-width-40 pega-auto-reply-item-area">
                <div
                  v-for="(sendImmediately, i) in autoReplyOptions.sendImmediatelies"
                  :key="i"
                  class="pega-entry-auto-reply-relative"
                >
                  <div>
                    <label class="pega-badge-radio pega-mr-5">
                      <input
                        :checked="autoReplySetting.isImmediatelySending === sendImmediately.value"
                        :value="sendImmediately.value"
                        type="radio"
                        :data-test="`sending-status-radio${i}`"
                        @change="onChangeImmediatelySendingRadio(sendImmediately.value)"
                      >
                      <span
                        class="pega-badge-radio-text pega-badge-radio-check-mark"
                        :data-test="`sending-status-label${i}`"
                      >{{ sendImmediately.label }}</span>
                    </label>
                  </div>
                  <div>
                    <label
                      v-for="(sendTime, j) in sendImmediately.sendTimes"
                      :key="j"
                      class="boss-checkbox pega-label-margin"
                      :data-test="`sending-time-label${sendTime.value}`"
                    >
                      <input
                        :checked="autoReplySetting.sendingTimes.includes(sendTime.value)"
                        :value="sendTime.value"
                        class="boss-input-checkbox"
                        type="checkbox"
                        :data-test="`sending-time-checkbox${sendTime.value}`"
                        @change="onChangeCheckTime"
                      > {{ sendTime.label }}
                    </label>
                  </div>
                </div>
                <div class="boss-layout boss-layout-start">
                  <span class="pega-send-time-label">※送信したい時刻にチェックをしてください（複数選択可）</span>
                </div>
              </div>
              <div class="pega-width-60 pega-annotation-text-padding">
                <div>■ 送信時間の設定について</div>
                <div>・応募頂いたタイミングでの即時送信か時間指定のいずれかを選択できます。</div>
              </div>
            </div>
          </template>
        </form-label>
        <form-label
          label="件名"
          is-required
        >
          <template #body>
            <div class="pega-width-40 pega-auto-reply-item-area">
              <small>（100文字以内）</small>
              <input
                v-model="autoReplySetting.mailSubject"
                class="boss-send-subject"
                type="text"
                data-test="mail-subject"
              >
            </div>
          </template>
        </form-label>
        <form-label
          label="本文"
          is-required
        >
          <template #body>
            <div class="pega-entry-auto-reply-relative">
              <div class="pega-width-40 pega-auto-reply-item-area">
                <small>（2,000文字以内）</small>
                <div class="boss-textarea-button">
                  <span
                    class="boss-button boss-button-compact"
                    data-test="user-name"
                    @click="insertionValue('■USER_NAME■ 様')"
                  >応募者名を挿入</span>
                  <span style="font-size: .8125rem; padding:4px 0">（本文にのみ有効）</span>
                </div>
                <textarea
                  ref="message"
                  v-model="autoReplySetting.mailText"
                  data-test="mail-text"
                  class="boss-send-textarea"
                  rows
                  cols
                />
              </div>
              <div class="pega-width-60 pega-annotation-text-padding">
                <div>■メッセージ作成について</div>
                <div class="margin-top-1">
                  応募者名挿入機能の使い方
                </div>
                <div>・本文にカーソルを合わせ、〔応募者名を挿入〕のボタンをクリックすると、≪ ■USER_NAME■ 様 ≫ と挿入されます。</div>
                <div>・メッセージ送信時に自動的に応募者名に変換されます。</div>
                <div>・ボタンを使用せずに、■USER_NAME■と直接記入して頂いても自動変換されますが、敬称がつきませんので、ご注意ください。</div>
                <div class="margin-top-1">
                  ■送信前にご確認いただきたいこと
                </div>
                <div class="pega-annotation-container margin-top-1">
                  <div>・応募後の選考プロセスや選考期間を明記していますか？</div>
                  <div>※選考方法や期間を明記することで応募者に安心感を与えることができます。</div>
                  <div class="margin-top-1">
                    例)
                  </div>
                  <div>「書類選考には1週間～10日程度お時間を頂いております。」</div>
                  <div>「弊社では、web応募書類/履歴書/職務経歴書をもとに選考しております。</div>
                  <div>お手数ではございますが、下記宛先に履歴書と職務経歴書をご送付頂けますでしょうか。</div>
                  <div>なお、書類選考には書類到着から1～2週間ほどお時間を頂いております。」</div>
                  <div class="margin-top-1">
                    ・不採用時の連絡の有無を明記していますか？
                  </div>
                  <div>※不採用の場合もご連絡することをお勧めしています。</div>
                  <div class="margin-top-1">
                    例）
                  </div>
                  <div>「選考の結果は、合否に関わらずご連絡致します。」</div>
                  <div>「選考の結果は、書類選考を通過された方にのみご連絡致します。」</div>
                </div>
              </div>
            </div>
          </template>
        </form-label>
        <form-label label="署名">
          <template #body>
            <div class="pega-width-40 pega-auto-reply-item-area">
              <small>（600文字以内）</small>
              <textarea
                v-model="autoReplySetting.mailSignature"
                data-test="mail-signature"
                class="pega-signature-textarea"
                rows
                cols
              />
            </div>
          </template>
        </form-label>
        <div class="margin-top-1 pega-flex-center">
          <button
            data-test="register-button"
            class="boss-button boss-button-confirm pega-button"
            @click="registerAutoReplySetting()"
          >
            <span
              class="boss-button-confirm-text"
              data-test="confirm-button"
            >
              上記内容で保存</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormLabel from '@/components/atoms/FormLabel'
import { entryAutoReplyOptions } from '@/lib/labelValueMappings'
import _ from 'lodash'

export default {
  components: {
    SettingHeader,
    FormLabel
  },
  data () {
    return {
      autoReplyOptions: entryAutoReplyOptions,
      autoReplySetting: {
        isAvailableAutoReplyMail: false,
        isNoAutoReplyForScoutEntry: false,
        isImmediatelySending: true,
        sendingTimes: [],
        mailSubject: '',
        mailText: '',
        mailSignature: null
      }
    }
  },
  computed: {
    requestParam () {
      return {
        isAvailableAutoReplyMail: this.autoReplySetting.isAvailableAutoReplyMail,
        isNoAutoReplyForScoutEntry: this.autoReplySetting.isNoAutoReplyForScoutEntry,
        isImmediatelySending: this.autoReplySetting.isImmediatelySending,
        sendingTimes: _.sortBy(this.autoReplySetting.sendingTimes),
        mailSubject: this.autoReplySetting.mailSubject,
        mailText: this.autoReplySetting.mailText,
        mailSignature: this.autoReplySetting.mailSignature
      }
    }
  },
  created () {
    this.fetchAutoReplySetting()
  },
  methods: {
    fetchAutoReplySetting () {
      this.$http.secured.get('/settings/entry_message_auto_reply').then(response => {
        const settings = response.data
        this.$set(this.autoReplySetting, 'isAvailableAutoReplyMail', settings.isAvailableAutoReplyMail)
        this.$set(this.autoReplySetting, 'isNoAutoReplyForScoutEntry', settings.isNoAutoReplyForScoutEntry)
        this.$set(this.autoReplySetting, 'isImmediatelySending', settings.isImmediatelySending)
        this.$set(this.autoReplySetting, 'sendingTimes', settings.sendingTimes)
        this.setMailSubject(settings.mailSubject)
        this.setMailText(settings.mailText)
        this.$set(this.autoReplySetting, 'mailSignature', settings.mailSignature)
      })
    },
    setMailSubject (mailSubject) {
      const setSubject = !_.isEmpty(mailSubject) ? mailSubject : 'ご応募ありがとうございます'
      this.$set(this.autoReplySetting, 'mailSubject', setSubject)
    },
    setMailText (mailText) {
      const setText = !_.isEmpty(mailText) ? mailText : '■USER_NAME■　様\n\nこの度は、弊社求人にご応募いただきまして誠にありがとうございます。\n\n合否につきましては、改めてご連絡申し上げますので、\n今しばらくお待ちくださいますようお願い致します。\n\n※本メールはご応募いただいた方への自動返信メールです。予めご了承下さい。'
      this.$set(this.autoReplySetting, 'mailText', setText)
    },
    registerAutoReplySetting () {
      this.$http.secured.post('/settings/entry_message_auto_reply', this.requestParam).then(response => {
        this.$toasted.global.success({ message: '設定内容を保存しました。' })
        this.$router.push({ name: 'dashboardTop' })
      })
    },
    insertionValue (value) {
      const cursorPosition = this.$refs.message.selectionStart
      this.$set(this.autoReplySetting, 'mailText', this.autoReplySetting.mailText.substr(0, cursorPosition) + value + this.autoReplySetting.mailText.substr(cursorPosition, this.autoReplySetting.mailText.length))
    },
    onChangeImmediatelySendingRadio (isImmediatelySending) {
      this.$set(this.autoReplySetting, 'isImmediatelySending', !this.autoReplySetting.isImmediatelySending)
      if (isImmediatelySending) {
        // 即時送信にチェック入れた場合は時刻を空にする
        this.$set(this.autoReplySetting, 'sendingTimes', [])
      }
    },
    onChangeCheckTime (e) {
      if (e.target.checked) {
        this.autoReplySetting.sendingTimes.push(Number(e.target.value))
      } else {
        this.autoReplySetting.sendingTimes = this.autoReplySetting.sendingTimes.filter(v => v !== Number(e.target.value))
      }
      this.$set(this.autoReplySetting, 'isImmediatelySending', false)
    }
  }
}
</script>
